import { LogTypes } from '@audibene/ta-browser-tracker'
import { useCallback } from 'react'
import { logRocket } from '../../startup'
import { logFactory } from '../../util'

type ErrorLogMessage = string | Error
type ErrorLogFunction = (error: ErrorLogMessage) => void

const log = logFactory('useTrackError')

const useTrackError = (): ErrorLogFunction => {
  const trackError = useCallback(
    (error: ErrorLogMessage) => {
      log('🟥 Tracking error...', { error, logRocket })
      try {
        if (error instanceof Error) {
          logRocket?.log(LogTypes.ERROR, error.message, { error })
        } else {
          logRocket?.log(LogTypes.ERROR, error)
        }

        log('🟥 Error tracked')
      } finally {
      }
    },
    [logRocket]
  )

  return trackError
}

export type { ErrorLogFunction }
export { useTrackError }
